<template>
  <div>
    <es-loader v-if="loading" style="margin: 20rem"/>
    <es-exception v-else-if="loadingError" margin="20rem"
      exceptionMessage="There was an issue. Please try again or contact your administrator."
    />
    <div v-else>
      <es-profile-header>
        <template #profile-header>
          <div class="columns">
            <div class="column">
              <div class="column-content">
                <div class="header-title">
                  {{ school.location.name ? school.location.name : undefined }}
                </div>
                <div class="header-subtitle">
                  {{ school.location.street1 ? school.location.street1 : undefined }}
                  {{ school.location.street2 ? school.location.street2 : undefined }}
                </div>
                <div class="header-subtitle">
                  {{ school.location.city ? school.location.city : undefined }}
                  {{ school.location.stateCode ? school.location.stateCode : undefined}}
                  {{ school.location.zip ? maskZip(school.location.zip) : undefined}}
                </div>
              </div>
            </div>
            <div class="column left-border is-flex flex-justify--center flex-align--center">
              <div class="column-content">
                <div class="header-subtitle is-flex flex-align--center">
                  <font-awesome-icon
                    :icon="['fas', 'envelope']"
                    size="1x"
                    style="margin-right: 0.5rem"
                    title="Email"
                  />
                  <span>
                    {{ school.location.adminEmail ? school.location.adminEmail : 'N/A' }}
                  </span>
                </div>
                <div class="header-subtitle">
                  <font-awesome-icon
                    :icon="['fas', 'phone']"
                    size="1x"
                    style="margin-right: 0.5rem"
                    title="Phone Number"
                  />
                  <span>
                    {{ school.location.adminPhone ? school.location.adminPhone : 'N/A' }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template #profile-overview>
          <div class="columns">
            <div class="column">
              <div class="column-content">
                <div class="column-title">
                  {{ status(school.location.active) }}
                </div>
                <div class="column-subtitle">
                  Status
                </div>
              </div>
            </div>
            <div class="column">
              <div class="column-content">
                <div class="column-title">
                  {{ school.location.startDate | formatDateMMDDYYYY }}
                </div>
                <div class="column-subtitle">
                  Start Date
                </div>
              </div>
            </div>
            <div class="column">
              <div class="column-content">
                <div class="column-title">
                  {{ school.location.endDate | formatDateMMDDYYYY }}
                </div>
                <div class="column-subtitle">
                  End Date
                </div>
              </div>
            </div>
            <div class="column">
              <div class="column-content">
                <div class="column-title">
                  {{ school.location.activeRecords ? school.location.activeRecords : 'N/A' }}
                </div>
                <div class="column-subtitle">
                  Active Records
                </div>
              </div>
            </div>
          </div>
        </template>
      </es-profile-header>
      <div class="tabs-container">
        <div class="tabs">
          <ul>
            <router-link
              :to="{
                 name: activeModule.name === 'directMatch'
                  ? 'DmSchoolInfoDetails'
                  :'PISchoolInfoDetails'
              }"
              tag="li"
              replace
            >
              <a>
                DETAILS
              </a>
            </router-link>
            <!-- <router-link
              v-if="activeModule.name === 'personId'"
              :to="{ name: 'PISchoolInfoDownloadOptions' }"
              tag="li"
              replace
            >
              <a>
                DOWNLOAD PERSON RECORDS
              </a>
            </router-link> -->
          </ul>
        </div>
      </div>
      <transition>
        <keep-alive>
          <router-view :school="school"/>
        </keep-alive>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEnvelope,
  faPhone,
} from '@fortawesome/pro-solid-svg-icons';
import EsException from '@/components/EsException.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsProfileHeader from '@/components/EsProfileHeader.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import NotificationManager from '@/mixins/NotificationManager';
import ZipUtils from '@/mixins/ZipUtils';
import FieldLabels from '@/mixins/FieldLabels';

library.add(
  faEnvelope,
  faPhone,
);
export default {
  mixins: [
    BreadcrumbsManager,
    NotificationManager,
    ZipUtils,
    FieldLabels,
  ],
  components: {
    EsException,
    EsLoader,
    EsProfileHeader,
  },
  data() {
    return {
      school: {},
      loading: null,
      loadingError: null,
    };
  },
  computed: {
    ...mapGetters({
      activeModule: 'appModules/getActiveModule',
      allModules: 'appModules/getAllModules',
    }),
  },
  created() {
    this.setBreadcrumbs();
    this.loadSchool();
  },
  methods: {
    ...mapActions([
      'getSchool',
    ]),
    ...mapActions('lookups', [
      'loadPersonTypes',
    ]),
    setBreadcrumbs() {
      const module = this.activeModule.name.trim();
      this.setBreadcrumb([
        { text: 'Home', to: { name: module } },
        { text: 'Location Information', to: {} },
      ]);
    },
    async loadSchool() {
      this.loading = true;
      this.loadingError = false;
      try {
        const { params } = this.$route;
        await this.getSchool({
          districtCode: params.districtCode,
          schoolCode: params.schoolCode,
        }).then((response) => {
          this.school = response.data;
        });
        await Promise.all([
          this.loadPersonTypes(),
        ]);
      } catch (error) {
        this.apiMsg = `${error.response.status === 500 ? 'Network Error' : error.response.data.message}`;
        this.showNotification('danger', [this.apiMsg]);
      } finally {
        this.loading = false;
      }
    },
    status(flag) {
      return flag ? 'Active' : 'Inactive';
    },
  },
};
</script>

<style lang="sass" scoped>
  .header-title
    font-size: 20px !important
  .header-subtitle
    font-size: 12px !important
  .text-light-grey
    color: #999999
  .left-border
    border-left: 1px solid #DEE2E6
</style>
